var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import set from "lodash.set";
import get from "lodash.get";
import typeSchema from "@readcube/rcp-meta/type_schema.json";
import { aliases } from "./tags";
const risTypeRcTypeMap = Object
    .entries(typeSchema.types)
    .reduce((acc, entry) => {
    const [rcTypeName, rcTypeDef] = entry;
    if (!rcTypeDef.ris_type)
        return acc;
    acc[rcTypeDef.ris_type] = rcTypeName;
    return acc;
}, {});
const cleanDoi = (doi) => doi.replace(/https?:\/\/(dx.)?doi.org\//, '');
const getRisTagRc = (rcTypeName) => {
    const fieldNames = typeSchema
        .types[rcTypeName]
        .fields;
    const risTagRc = fieldNames
        .reduce((acc, fieldName) => {
        const fieldDef = typeSchema
            .field_defs[fieldName];
        if (fieldDef && ("ris" in fieldDef)) {
            let risTags = [fieldDef.ris];
            if (fieldDef.ris.includes(',')) {
                const multiRisTags = fieldDef
                    .ris
                    .split(',')
                    .map(r => r.trim())
                    .filter(r => r);
                if (multiRisTags === null || multiRisTags === void 0 ? void 0 : multiRisTags.length)
                    risTags = multiRisTags;
            }
            if ("readcube" in fieldDef)
                risTags.forEach(tag => {
                    acc[tag] = { path: fieldDef.readcube, isArray: fieldDef.input.array };
                });
            if ("custom_metadata" in fieldDef)
                risTags.forEach(tag => {
                    acc[tag] = {
                        path: 'custom_metadata.' + fieldDef.custom_metadata,
                        isArray: fieldDef.input.array,
                    };
                });
        }
        return acc;
    }, {});
    return risTagRc;
};
const findTag = (risItem, tagName) => risItem
    .tags
    .find(t => t.tag === tagName);
export const risItemToRcItem = (risItem, text, hash, errors, opts) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g;
    const entryText = text.slice(risItem.startLocation, risItem.endLocation);
    const originalId = yield hash(entryText);
    let rcItem = {
        import_data: {
            original_id: originalId
        }
    };
    let risType = (_a = findTag(risItem, "TY")) === null || _a === void 0 ? void 0 : _a.content;
    const rcItemType = (risType && risTypeRcTypeMap[risType]) || "article";
    set(rcItem, "item_type", rcItemType);
    const risTagRc = getRisTagRc(rcItemType);
    const isContentTag = (tag) => !["TY", "ER"].includes(tag.tag);
    const hasContent = (tag) => tag.content && tag.content.length;
    risItem
        .tags
        .map(t => {
        const alias = aliases[t.tag];
        if (!alias)
            return t;
        const aliasedTag = Object.assign(Object.assign({}, t), { tag: aliases[t.tag] });
        return aliasedTag;
    })
        .filter(t => isContentTag(t) && hasContent(t))
        .forEach(t => {
        var _a, _b;
        if (t.tag === 'UR' && t.content.includes('readcube.com/library'))
            return;
        if (t.tag === 'EP') {
            const pagination = get(rcItem, 'article.pagination', '0') + '-' + t.content;
            set(rcItem, 'article.pagination', pagination);
            return;
        }
        if (t.tag === 'L1') {
            const files = get(rcItem, 'files', []);
            files.push({ import_path: t.content });
            set(rcItem, 'files', files);
        }
        if (t.tag === 'N1') {
            let notes = get(rcItem, 'user_data.notes', '');
            notes =
                (notes === null || notes === void 0 ? void 0 : notes.length)
                    ? notes + '\n' + t.content
                    : t.content;
            set(rcItem, 'user_data.notes', notes);
            return;
        }
        if (t.tag === 'N2') {
            let abstract = get(rcItem, 'article.abstract', '');
            if (!abstract.length) {
                set(rcItem, 'article.abstract', t.content);
            }
            else {
                let notes = get(rcItem, 'user_data.notes', '');
                notes =
                    (notes === null || notes === void 0 ? void 0 : notes.length)
                        ? notes + '\n' + t.content
                        : t.content;
                set(rcItem, 'user_data.notes', notes);
            }
            return;
        }
        const rc = risTagRc[t.tag];
        if (!rc)
            return;
        if (rc.path) {
            if (rc.isArray) {
                const valArray = get(rcItem, rc.path, []);
                // special case for Endnote keywords. Endnote does not set multiple KW tags (as it should)
                // but sets all keywords in one tag and delimits them by newline
                if (t.tag === 'KW') {
                    let keywords = [];
                    keywords =
                        (_b = (_a = t.content) === null || _a === void 0 ? void 0 : _a.split('\n')) === null || _b === void 0 ? void 0 : _b.filter(f => f);
                    if ((opts === null || opts === void 0 ? void 0 : opts.keywordDestination) === 'notes') {
                        let notes = get(rcItem, 'user_data.notes', '');
                        notes =
                            (notes === null || notes === void 0 ? void 0 : notes.length)
                                ? notes + '\n' + keywords.join(', ')
                                : keywords.join('\n');
                        set(rcItem, 'user_data.notes', notes);
                    }
                    else {
                        set(rcItem, rc.path, [...valArray, ...keywords]);
                    }
                    return;
                }
                if (['AU', 'A1', 'A2', 'A3', 'A4'].includes(t.tag)) {
                    let authorVal = t.content;
                    if ((opts === null || opts === void 0 ? void 0 : opts.removeSquareBracketsFromAuthors) && t.content.includes('['))
                        t.content = t.content.replace(/\[.*\]/, '').trim();
                    if (t.content.includes(',')) {
                        let nameParts = t.content.split(',');
                        const firstNamePart = (nameParts.pop() || "").trim();
                        const lastNameParts = nameParts.join(',').trim();
                        authorVal = firstNamePart + ' ' + lastNameParts;
                    }
                    valArray.push(authorVal);
                    set(rcItem, rc.path, valArray);
                    return;
                }
                valArray.push(t.content);
                set(rcItem, rc.path, valArray);
            }
            else {
                let val = t.content;
                if (rc.path === 'ext_ids.doi')
                    val = cleanDoi(t.content);
                if (rc.path === 'custom_metadata.date')
                    val =
                        t.content
                            .split('/')
                            .filter(f => f)
                            .join('-');
                set(rcItem, rc.path, val);
            }
        }
    });
    const hasTitleOrExtIds = ((_b = rcItem === null || rcItem === void 0 ? void 0 : rcItem.article) === null || _b === void 0 ? void 0 : _b.title) != null
        || (rcItem.ext_ids
            && Object.values(rcItem.ext_ids).filter(v => v).length);
    if (!hasTitleOrExtIds) {
        errors.push({
            severity: 'error',
            message: `Cannot convert. Ris item does not contain enough data. Ensure that item has a title or doi present. ${risItem.tags[0].line}:${risItem.tags[0].column}}`,
            column: risItem.tags[0].column,
            line: risItem.tags[0].line,
        });
        return;
    }
    const yearIsNotSetButDateIsAvailable = !((_c = rcItem === null || rcItem === void 0 ? void 0 : rcItem.article) === null || _c === void 0 ? void 0 : _c.year)
        && ((_d = rcItem === null || rcItem === void 0 ? void 0 : rcItem.custom_metadata) === null || _d === void 0 ? void 0 : _d.date);
    if (yearIsNotSetButDateIsAvailable) {
        if (!rcItem.article)
            rcItem.article = {};
        const date = rcItem.custom_metadata.date;
        const extractedYear = (_g = (_f = (_e = /(?<matchedYear>\d{1,4})/) === null || _e === void 0 ? void 0 : _e.exec(date)) === null || _f === void 0 ? void 0 : _f.groups) === null || _g === void 0 ? void 0 : _g.matchedYear;
        if (extractedYear)
            rcItem.article.year = extractedYear;
    }
    return rcItem;
});
